import { c as _c } from "react/compiler-runtime";
import { type ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@shared-components/shadcn/chart";
import { api } from "@shared-server/api";
import { Bar, ComposedChart, CartesianGrid, Line, XAxis, YAxis, Legend } from "recharts";
import { formatGranularDateTick } from "./metric-utils";
import type { GranularityType } from "@shared-server/api/routers/queries/metrics/utils";
import { useDepartmentStackContext } from "@shared-components/department-stack-provider";
const chartConfig: ChartConfig = {
  count: {
    label: "Images"
  }
};
type ImagesProps = {
  startDate: Date;
  endDate: Date;
  granularity: GranularityType;
};
export const Images = props => {
  const $ = _c(20);
  const {
    parentDepartmentId
  } = useDepartmentStackContext();
  let t0;
  if ($[0] !== parentDepartmentId || $[1] !== props.endDate || $[2] !== props.granularity || $[3] !== props.startDate) {
    t0 = {
      startDate: props.startDate,
      endDate: props.endDate,
      granularity: props.granularity,
      parentDepartmentId
    };
    $[0] = parentDepartmentId;
    $[1] = props.endDate;
    $[2] = props.granularity;
    $[3] = props.startDate;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const coreMetricsQuery = api.coreMetrics.imagesAttempted.useQuery(t0);
  let t1;
  if ($[5] !== coreMetricsQuery.data?.chartData) {
    t1 = coreMetricsQuery.data?.chartData ?? [];
    $[5] = coreMetricsQuery.data?.chartData;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const chartData = t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="mb-4">{"Images"}</h2>;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CartesianGrid vertical={false} />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props.granularity) {
    t4 = <XAxis dataKey="date" tickLine={false} axisLine={false} tickMargin={8} minTickGap={32} tickFormatter={value => formatGranularDateTick(value, props.granularity)} />;
    $[9] = props.granularity;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <YAxis yAxisId="countItems" dataKey="countItems" interval={1} orientation="left" />;
    t6 = <YAxis yAxisId="countItemsCumulative" dataKey="countItemsCumulative" interval={1} orientation="right" />;
    $[11] = t5;
    $[12] = t6;
  } else {
    t5 = $[11];
    t6 = $[12];
  }
  let t10;
  let t7;
  let t8;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ChartTooltip content={<ChartTooltipContent nameKey="date" labelFormatter={_temp} />} />;
    t8 = <Legend />;
    t9 = <Bar yAxisId="countItems" dataKey="countItems" className="fill-ter-yellow-600" fill="#eaaa00" />;
    t10 = <Line yAxisId="countItemsCumulative" dataKey="countItemsCumulative" dot={false} className="stroke-ter-yellow-600" stroke="#eaaa00" />;
    $[13] = t10;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t10 = $[13];
    t7 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  let t11;
  if ($[17] !== chartData || $[18] !== t4) {
    t11 = <div>{t2}<ChartContainer config={chartConfig} className="aspect-auto h-[150px] w-full"><ComposedChart accessibilityLayer={true} data={chartData}>{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}</ComposedChart></ChartContainer></div>;
    $[17] = chartData;
    $[18] = t4;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};
function _temp(value_0) {
  return value_0;
}